/**
 * @ngdoc filter
 * @name ims.shared.filter:trusted
 * @function
 * @description
 * Makes a url a trusted URL. Required for ng-src with an external domain.
 *
 */
export function trustedFilter($sce) {
    'ngInject';
    return function (url) {
        return $sce.trustAsResourceUrl(url);
    };
}
